import { z } from 'zod';

export const resultsTourGeneralCo2DtoSchema = z
  .object({
    score: z.number(),
    sections: z.object({
      CREATION: z.object({
        score: z.number(),
        categories: z.object({
          SCENOGRAPHY: z.object({ score: z.number() }),
          TEAM_MOBILITY: z.object({ score: z.number() }),
          REPEATS_AND_MATERIAL: z.object({ score: z.number() }),
        }),
      }),
      MANAGEMENT: z.object({
        score: z.number(),
        categories: z.object({
          TEAM_MOBILITY: z.object({ score: z.number() }),
          CATERING: z.object({ score: z.number() }),
          OFFICE: z.object({ score: z.number() }),
        }),
      }),
      COMMUNICATION: z.object({
        score: z.number(),
        categories: z.object({
          MERCHANDISING: z.object({ score: z.number() }),
          ADVERTISING: z.object({ score: z.number() }),
          VIDEO_AND_DIGITAL: z.object({ score: z.number() }),
          TICKETING: z.object({ score: z.number() }),
        }),
      }),
    }),
  })
  .optional();
